<template>
  <div class="my-box" :class="[selected ? 'selected' : '']">
    <!-- <YouKuStatusBar :item="item" /> -->
    <el-image
      class="my-el-image"
      :src="item.pictureUrl | getImgById"
      fit="contain"
    />
    <div class="play-box">
      <i v-if="showSort" class="select-sort">{{ sort }}</i>

      <i v-else class="el-icon-check"></i>
    </div>
  </div>
</template>
<script>
import YouKuStatusBar from '../../YouKuStatusBar/YouKuStatusBar.vue';
export default {
  components: { YouKuStatusBar },
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    sort: {
      type: Number,
      default: -1,
    },
    showSort: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.my-box {
  position: relative;
  .play-box {
    display: none;
  }
  &.selected {
    .play-box {
      display: flex;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      align-items: center;
    }
    i {
      margin: 0 auto;
      border-radius: 50%;
      overflow: hidden;
      background-color: $assistColor;
      padding: 5px;
      font-size: 24px;
      text-align: center;
      color: #fff;
      &.select-sort {
        font-style: normal;
        display: inline-block;
        width: 35px;
        height: 35px;
        line-height: 35px;
        padding: 0;
        font-size: 18px;
      }
    }
    .my-el-image {
      opacity: 0.2;
    }
  }
}

.my-el-image {
  margin-bottom: 10px;
  border: 1px solid #ddd;
  width: 100%;
  height: 150px;
}
</style>
